import React, { useEffect } from 'react';
import { Portal, Transition } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import { Sidebar } from '../sidebar/sidebar';
import './mobile-drawer.css';

interface MobileDrawerProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Mobile Drawer Layout Component.
 * Custom implementation using Mantine's Transition and Portal for robustness,
 * but with custom HTML and CSS for complete UI control.
 */
export const MobileDrawer: React.FC<MobileDrawerProps> = ({ open, onClose }) => {
  // Prevent scrolling when drawer is open
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  return (
    <Portal>
      <Transition mounted={open} transition="fade" duration={200} timingFunction="ease">
        {styles => (
          <div className="cb-drawer-overlay" style={styles} onClick={onClose} aria-hidden="true" />
        )}
      </Transition>

      <Transition mounted={open} transition="slide-right" duration={250} timingFunction="ease">
        {styles => (
          <div className="cb-drawer" style={styles} role="dialog" aria-modal="true">
            <div className="cb-drawer__header">
              <span className="cb-logo cb-logo-main">{'CB'}</span>
              <button className="cb-drawer__close" onClick={onClose} aria-label="Close navigation">
                <IconX size={20} />
              </button>
            </div>
            <div className="cb-drawer__body">
              <Sidebar onNavigate={onClose} />
            </div>
          </div>
        )}
      </Transition>
    </Portal>
  );
};
